"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizationAdminApi = void 0;
var runtime = __importStar(require("../runtime"));
/**
 *
 */
var LocalizationAdminApi = /** @class */ (function (_super) {
    __extends(LocalizationAdminApi, _super);
    function LocalizationAdminApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates request options for localizationAdminControllerBackfillV1 without sending the request
     */
    LocalizationAdminApi.prototype.localizationAdminControllerBackfillV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                queryParameters = {};
                headerParameters = {};
                urlPath = "/v1/admin/localization/translations/backfill";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'POST',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Enqueue backfill for a language and aggregate type
     */
    LocalizationAdminApi.prototype.localizationAdminControllerBackfillV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localizationAdminControllerBackfillV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Enqueue backfill for a language and aggregate type
     */
    LocalizationAdminApi.prototype.localizationAdminControllerBackfillV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localizationAdminControllerBackfillV1Raw(initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for localizationAdminControllerGetCostV1 without sending the request
     */
    LocalizationAdminApi.prototype.localizationAdminControllerGetCostV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                queryParameters = {};
                headerParameters = {};
                urlPath = "/v1/admin/localization/cost";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Get translation cost meter totals
     */
    LocalizationAdminApi.prototype.localizationAdminControllerGetCostV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localizationAdminControllerGetCostV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Get translation cost meter totals
     */
    LocalizationAdminApi.prototype.localizationAdminControllerGetCostV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localizationAdminControllerGetCostV1Raw(initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for localizationAdminControllerListJobsV1 without sending the request
     */
    LocalizationAdminApi.prototype.localizationAdminControllerListJobsV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['status'] == null) {
                    throw new runtime.RequiredError('status', 'Required parameter "status" was null or undefined when calling localizationAdminControllerListJobsV1().');
                }
                if (requestParameters['aggregateType'] == null) {
                    throw new runtime.RequiredError('aggregateType', 'Required parameter "aggregateType" was null or undefined when calling localizationAdminControllerListJobsV1().');
                }
                if (requestParameters['limit'] == null) {
                    throw new runtime.RequiredError('limit', 'Required parameter "limit" was null or undefined when calling localizationAdminControllerListJobsV1().');
                }
                queryParameters = {};
                if (requestParameters['status'] != null) {
                    queryParameters['status'] = requestParameters['status'];
                }
                if (requestParameters['aggregateType'] != null) {
                    queryParameters['aggregateType'] = requestParameters['aggregateType'];
                }
                if (requestParameters['limit'] != null) {
                    queryParameters['limit'] = requestParameters['limit'];
                }
                headerParameters = {};
                urlPath = "/v1/admin/localization/translations/jobs";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * List translation jobs
     */
    LocalizationAdminApi.prototype.localizationAdminControllerListJobsV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localizationAdminControllerListJobsV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * List translation jobs
     */
    LocalizationAdminApi.prototype.localizationAdminControllerListJobsV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localizationAdminControllerListJobsV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for localizationAdminControllerRetryJobV1 without sending the request
     */
    LocalizationAdminApi.prototype.localizationAdminControllerRetryJobV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['id'] == null) {
                    throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling localizationAdminControllerRetryJobV1().');
                }
                queryParameters = {};
                headerParameters = {};
                urlPath = "/v1/admin/localization/translations/jobs/{id}/retry";
                urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'POST',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Retry a failed translation job
     */
    LocalizationAdminApi.prototype.localizationAdminControllerRetryJobV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localizationAdminControllerRetryJobV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Retry a failed translation job
     */
    LocalizationAdminApi.prototype.localizationAdminControllerRetryJobV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localizationAdminControllerRetryJobV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return LocalizationAdminApi;
}(runtime.BaseAPI));
exports.LocalizationAdminApi = LocalizationAdminApi;
